import { getEntity } from 'data'
import { createSelector } from 'reselect'
import { getOrganizationId } from '../organizations/selectors'
import { hasFeatureFlag } from 'data/organizations/selectors'
import { selectors as OrganizationsSelector } from 'data/organizations'

export const getOrganizationPaymentInfos = createSelector(
  state => state,
  getOrganizationId,
  (state, organizationId) => getEntity(state, 'PaymentInfos', organizationId)
)

export function getOrganizationCoupon(state) {
  const paymentInfos = getOrganizationPaymentInfos(state)
  return (
    paymentInfos &&
    paymentInfos.coupon &&
    getEntity(state, 'Coupon', paymentInfos.coupon.id)
  )
}

export const getOrganizationPlan = createSelector(
  state => state,
  getOrganizationPaymentInfos,
  (state, paymentInfos) => {
    return (
      paymentInfos &&
      paymentInfos.plan &&
      getEntity(state, 'Plan', paymentInfos.plan.id)
    )
  }
)

export const isLimited = createSelector(
  state => state,
  OrganizationsSelector.isFree,
  (state, isFree) => isFree && !hasFeatureFlag(state, 'bypass-limits')
)

export const getOrganizationSubscription = createSelector(
  state => state,
  getOrganizationPaymentInfos,
  (state, paymentInfos) => {
    return (
      paymentInfos &&
      paymentInfos.subscription &&
      getEntity(state, 'PlanSubscription', paymentInfos.subscription.id)
    )
  }
)
